import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, Phone } from 'lucide-react';

const MobileMenu = ({ navigationData, isActive, onClose, getNavIcon, getDropdownIcon }) => {
  const [openMobileDropdown, setOpenMobileDropdown] = useState(null);

  const toggleDropdown = (index) => {
    setOpenMobileDropdown(openMobileDropdown === index ? null : index);
  };

  return (
    <div className="md:hidden bg-white border-t border-gray-200 shadow-lg max-h-[calc(100vh-5rem)] overflow-y-auto">
      <div className="px-4 py-2 space-y-2">
        {navigationData.navLinks.map((link, index) => (
          <div key={link.name} className="border-b border-gray-100 last:border-0">
            {link.dropdown ? (
              <>
                <button
                  onClick={() => toggleDropdown(index)}
                  className={`w-full flex justify-between items-center py-3 ${
                    isActive(link.path)
                      ? 'text-gold font-medium'
                      : 'text-primary-blue hover:text-gold'
                  }`}
                >
                  <span className="flex items-center space-x-2">
                    {getNavIcon(link.name)}
                    <span>{link.name}</span>
                  </span>
                  <ChevronDown
                    className={`w-4 h-4 transition-transform duration-200 ${
                      openMobileDropdown === index ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                
                {openMobileDropdown === index && (
                  <div className="pl-8 pb-3 space-y-2">
                    {link.dropdown.map((item) => (
                      <Link
                        key={item.path}
                        to={item.path}
                        onClick={onClose}
                        className={`flex items-center space-x-2 py-2 ${
                          isActive(item.path, true)
                            ? 'text-gold font-medium'
                            : 'text-gray-600 hover:text-gold'
                        }`}
                      >
                        {getDropdownIcon(item.name)}
                        <span>{item.name}</span>
                      </Link>
                    ))}
                  </div>
                )}
              </>
            ) : (
              <Link
                to={link.path}
                onClick={onClose}
                className={`flex items-center space-x-2 py-3 ${
                  isActive(link.path, link.exact)
                    ? 'text-gold font-medium'
                    : 'text-primary-blue hover:text-gold'
                }`}
              >
                {getNavIcon(link.name)}
                <span>{link.name}</span>
              </Link>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MobileMenu;